import { useQuery } from "@tanstack/react-query";

import { supportService } from "@/app/services/supportService";
import { SupportCategoryEnum } from "@/app/utils/supportCategoryEnum";

export const SUPPORT_DOCUMENTS_QUERY_KEY = "supportDocuments";

interface UseSupportDocumentsParams {
  enabled?: boolean;
  poll?: boolean;
}

export const useSupportDocuments = ({
  enabled = true,
  poll = false,
}: UseSupportDocumentsParams = {}) =>
  useQuery({
    queryKey: [SUPPORT_DOCUMENTS_QUERY_KEY],
    queryFn: () =>
      supportService.createSupport({
        search: "",
        categories: [SupportCategoryEnum.TRANSACTION],
        documents: true,
        saveHistory: false,
      }),
    enabled,
    staleTime: 60 * 1000,
    ...(poll && {
      refetchInterval: 60_000,
      refetchIntervalInBackground: true,
    }),
  });
